export { default } from './BranchesStore';



// WEBPACK FOOTER //
// ./src/stores/BranchesStore/index.ts